import { render, staticRenderFns } from "./PayerListing.vue?vue&type=template&id=2851203c&scoped=true"
import script from "./PayerListing.vue?vue&type=script&lang=js"
export * from "./PayerListing.vue?vue&type=script&lang=js"
import style0 from "./PayerListing.vue?vue&type=style&index=0&id=2851203c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851203c",
  null
  
)

export default component.exports